/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ToolPencilIcon16Light } from './ToolPencilIcon16Light';
import { ToolPencilIcon16Regular } from './ToolPencilIcon16Regular';
import { ToolPencilIcon16Solid } from './ToolPencilIcon16Solid';
import { ToolPencilIcon20Light } from './ToolPencilIcon20Light';
import { ToolPencilIcon20Regular } from './ToolPencilIcon20Regular';
import { ToolPencilIcon20Solid } from './ToolPencilIcon20Solid';
import { ToolPencilIcon24Regular } from './ToolPencilIcon24Regular';
import { ToolPencilIcon24Solid } from './ToolPencilIcon24Solid';
import { ToolPencilIcon32Regular } from './ToolPencilIcon32Regular';
import { ToolPencilIcon64Regular } from './ToolPencilIcon64Regular';
var sizes = {
    16: {
        light: ToolPencilIcon16Light,
        regular: ToolPencilIcon16Regular,
        solid: ToolPencilIcon16Solid,
    },
    20: {
        light: ToolPencilIcon20Light,
        regular: ToolPencilIcon20Regular,
        solid: ToolPencilIcon20Solid,
    },
    24: {
        regular: ToolPencilIcon24Regular,
        solid: ToolPencilIcon24Solid,
    },
    32: {
        regular: ToolPencilIcon32Regular,
    },
    64: {
        regular: ToolPencilIcon64Regular,
    },
};
export var ToolPencilIcon = forwardRef('ToolPencilIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
